<div class="background">
    <div class="dialog-header">
        <h2>Import Translations</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div style="display: flex; justify-content: center">
        <h3> {{ version ? version.name : product?.name }}</h3>
    </div>

    <div>
        <label class="custom-label">Language</label>
        <mat-form-field style="width: 100%; margin-top: 10px">
            <mat-select [formControl]="selectedLanguage">
                @for (language of (languages$ | async); track language.id) {
                    @if (language.id !== 1) {
                        <mat-option [value]="language">{{ language.name }}
                        </mat-option>
                    }
                }
            </mat-select>
        </mat-form-field>
    </div>

    <mat-card
            [ngClass]="{'status-added': (importedTranslation$ | async) === true, 'status-failed': (importedTranslation$ | async) === false, 'status-not-added': !importPressed}"
            class="add-card"
            id="add">
        <mat-spinner *ngIf="(importedTranslation$ | async) === null && importPressed" style="margin: auto"/>
        <p>{{
                (importedTranslation$ | async) !== null ? ((importedTranslation$ | async) ? "Translation File imported" : "Translation File could not be imported.") :
                    "No Translation File imported."
            }}</p>
    </mat-card>

    <div class="file">
        <!--        class="upload-button"-->
        <button (click)="fileUpload.click()" color="primary"
                mat-mini-fab>
            <mat-icon>attach_file</mat-icon>
        </button>
        <p style="margin-left: 10px">{{ fileName || "No Translation File uploaded." }}</p>
    </div>

    <input #fileUpload (change)="uploadFile($event)"
           [accept]="requiredFileType"
           class="file-input" type="file">
    <div>
        <span [matTooltipDisabled]="!(fileName === '')" matTooltip="No File selected" matTooltipPosition="above"
              class="div-button">
            <button (click)="importFile()" color="primary" mat-raised-button [disabled]="fileName === '' ||
                !((permissionService.accessRights$|async)?.userRight_RIS2_IMPORT_TRANSLATION_VERSION$|async) || this.selectedLanguage.value?.id === 1">
                <mat-icon>add</mat-icon>
                Import Translations File
            </button>
        </span>
    </div>
</div>

